module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAIVBMVEXV3OTV3OTV3OTV3OTV3OTt8PPk6O3p7fDe5OrZ3+fl6e5EVCNdAAAABHRSTlPm50pJ6bzg4AAAAD5JREFUGNNjMHCBAmYGFhjTgcEFDqjFTIEzp4fAmB6hcGZqaGgohOkVCgQYogi1CBMQ5lLuSITnHRkUYUwmACI5RhKWnJuEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_previous1.png
// module id = N5Ca
// module chunks = 9